export default "__VITE_ASSET__CqNLNqSa__"